import { i18n as _i18n } from "@lingui/core";
import { CarleadCreationButton, CarleadCreationForm, CarleadLicensePlate, CarleadMileageFormatted, defaultCarleadCreationFlow, defaultLPSearchCarleadCreationFlow, lowMileageValidatorProps, LPDataFieldsVisibilityToggle, LPSearchMainTypeDetails, LPSearchMainTypesSub, PricedCarsCounter, QuestionnaireSelect, renderFieldVerticalWrapper, useCreateCarleadChainedRequest, useCreateNormalCarleadForm, useFormQuestionnaireProps, useLicensePlateSearchChainRequest, useLicensePlateSearchProps, useLicensePlateSearchService } from '@wkda/carlead-creation-components';
import cx from 'classnames';
import { useTrackLanding } from '@wkda/funnel-components';
import { Paper } from '@wkda/styleguide';
import CarleadProgress from '../../../../../../components/carlead/CarleadProgress';
import TrustPilot from '../../../../../../components/appointment/TrustPilot';
import ReturningCustomerPopup from '../../../../../../components/carlead/ReturningCustomerPopup';
import EmailWithTracking from '../../../../../../components/carlead/EmailWithTracking';
import { CheckSuspiciousMileageMethod } from '@wkda/funnel-utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadLicensePlateSECustomerCounter = ({
  wide = false,
  className = ''
}) => {
  const questionnaireProps = useFormQuestionnaireProps(defaultCarleadCreationFlow);
  const service = useLicensePlateSearchService(defaultLPSearchCarleadCreationFlow);
  const licenseSearchPlateProps = useLicensePlateSearchProps(service);
  const request = useCreateCarleadChainedRequest([
  // make this the last one
  useLicensePlateSearchChainRequest()]);
  const consumerForm = useCreateNormalCarleadForm([questionnaireProps, licenseSearchPlateProps, lowMileageValidatorProps]);
  useTrackLanding();
  return /*#__PURE__*/_jsxs(Paper, {
    className: "carlead-creation-form__container license-plate",
    children: [/*#__PURE__*/_jsx(ReturningCustomerPopup, {}), /*#__PURE__*/_jsx("div", {
      className: `box gap full-height ${className}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: cx('container', {
          'container-xl': wide
        }),
        children: [/*#__PURE__*/_jsx(PricedCarsCounter, {}), /*#__PURE__*/_jsxs(CarleadCreationForm, {
          carleadForm: consumerForm,
          machineService: service,
          submitHandler: request,
          children: [/*#__PURE__*/_jsx(CarleadLicensePlate, {
            country: "SE"
          }), /*#__PURE__*/_jsxs(LPDataFieldsVisibilityToggle, {
            children: [/*#__PURE__*/_jsx(LPSearchMainTypeDetails, {
              renderFieldWrapper: renderFieldVerticalWrapper
            }), /*#__PURE__*/_jsx(LPSearchMainTypesSub, {
              renderFieldWrapper: renderFieldVerticalWrapper
            })]
          }), /*#__PURE__*/_jsx(CarleadMileageFormatted, {
            lowerThreshold: 1000,
            upperThreshold: 50000,
            suspiciousMileageMessageDelay: 2000,
            isHiddenField: true,
            renderFieldWrapper: renderFieldVerticalWrapper,
            suspiciousMileageCheckType: CheckSuspiciousMileageMethod.Normal
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELLPOINT",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellpoint',
              message: "Wann planst du den Verkauf?"
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNow',
                message: "Schnellstm\xF6glich"
              }),
              value: 'SELLPOINT_NOW'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint4weeks',
                message: "In den n\xE4chsten 4 Wochen"
              }),
              value: 'SELLPOINT_4_WEEKS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint3months',
                message: "In den n\xE4chsten 3 Monaten"
              }),
              value: 'SELLPOINT_3_MONTHS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNotPlanned',
                message: "Ich plane nicht zu verkaufen"
              }),
              value: 'SELLPOINT_NOT_PLANNED'
            }]
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            name: "SELL_TYPES",
            renderFieldWrapper: renderFieldVerticalWrapper,
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellTypes',
              message: "Welchen Verkauf bevorzugst du?"
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesPrivate',
                message: "An Privat"
              }),
              value: 'PRIVATE'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesDealer',
                message: "An H\xE4ndler"
              }),
              value: 'DEALER'
            }]
          }), /*#__PURE__*/_jsx(EmailWithTracking, {}), /*#__PURE__*/_jsx(CarleadProgress, {}), /*#__PURE__*/_jsx(CarleadCreationButton, {})]
        }), /*#__PURE__*/_jsxs("section", {
          className: "trust-box",
          children: [/*#__PURE__*/_jsx("div", {
            className: "d-none d-md-block",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "desktop"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "d-block d-md-none",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "mobile"
            })
          })]
        })]
      })
    })]
  });
};
export default CarleadLicensePlateSECustomerCounter;